export default __webpack_public_path__ + "static/media/IMG_6067 copy - Copy.5f417def.jpg";